import React, { useEffect, useState } from "react";
import { useLang } from "@/i18n/LanguageContext";
import { Download, X } from "lucide-react";

export const InstallPrompt = () => {
  const { t } = useLang();
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("maqam_install_dismissed") === "1") return;
    if (window.matchMedia("(display-mode: standalone)").matches) return;

    // count visits
    const visits = parseInt(localStorage.getItem("maqam_visits") || "0", 10) + 1;
    localStorage.setItem("maqam_visits", String(visits));

    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      if (visits >= 3) setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const dismiss = () => {
    localStorage.setItem("maqam_install_dismissed", "1");
    setShow(false);
  };

  const install = async () => {
    if (!deferred) return dismiss();
    deferred.prompt();
    await deferred.userChoice;
    dismiss();
  };

  if (!show) return null;

  return (
    <div className="fixed inset-x-0 bottom-[74px] z-[55] px-4 pb-safe" data-testid="install-prompt">
      <div className="mx-auto flex max-w-xl items-center gap-3 rounded-2xl bg-white p-4 shadow-[0_16px_40px_-12px_rgba(10,25,47,0.3)] ring-1 ring-slate-200 animate-fade-up">
        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-[#0A192F] text-[#E9CE7D]">
          <Download size={19} strokeWidth={1.75} />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold text-[#0A192F]">{t("install.title")}</p>
          <p className="mt-0.5 text-xs leading-snug text-slate-500">{t("install.body")}</p>
        </div>
        <div className="flex shrink-0 items-center gap-1.5">
          <button
            onClick={install}
            data-testid="install-accept"
            className="rounded-full bg-[#D4AF37] px-4 py-2 text-xs font-bold text-[#0A192F] transition-colors hover:bg-[#E9CE7D]"
          >
            {t("install.cta")}
          </button>
          <button onClick={dismiss} data-testid="install-dismiss" aria-label={t("install.later")} className="grid h-8 w-8 place-items-center rounded-full text-slate-400 hover:bg-slate-100">
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};
